module.exports = __webpack_public_path__ + "img/approve-list12.9bbfb565.png";